import { Default, Detail,  List, Create } from "./views";

const Module = {
    name: "pianocontices",
    defaultRoutePath: "/incomestatements/pianocontice",
    menuItemScope: "incomestatements",
    menuItemName: "pianocontices",
    routes: [
        {
            path: "/incomestatements/pianocontice",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
